import ClipboardJS from 'clipboard';
import tippy from 'tippy.js';

export default function enableClipboard() {
  var clipboard = new ClipboardJS('.js-clipboard-button');

  clipboard.on('success', function (e) {
    var tooltipContent = e.trigger.getAttribute('data-tooltip-content');
    // the wrapping timeout is needed for the instantiating of the tooltip
    // see also the documentation https://atomiks.github.io/tippyjs/tippy-instance/
    setTimeout(function () {
      showToolTip(e.trigger, tooltipContent);
    });
  });

  clipboard.on('error', function (e) {
    var tooltipContent = e.trigger.getAttribute('data-tooltip-error');
    setTimeout(function () {
      showToolTip(e.trigger, tooltipContent);
    });
  });

  function showToolTip(element, content) {
    // Check if element is inside a popover
    const popover = element.closest('[popover]');
    const appendTo = popover || document.body;

    tippy(element, { appendTo: appendTo });
    var instance = element._tippy;
    instance.setContent(content);
    instance.show(300);
    setTimeout(instance.destroy, 1300);
  }
}
